import { Dialog } from './Dialog.main';

export { Dialog };
